import type { ClawSession } from '@src/stores/useClawWsStore';

/**
 * 新接口 `GET /agent/mario-agent/threads` 返回的单条结构（与 swagger 对齐；模型为空时在此收窄）
 */
export type MarioAgentThreadListRow = {
  threadId?: string;
  marioAgentId?: string;
  title?: string;
  titleSource?: string;
  status?: string;
  messageCount?: number;
  lastMessagePreview?: string;
  lastMessageAt?: string;
  lastTaskId?: string;
  lastTaskStatus?: string;
  createdAt?: string;
  updatedAt?: string;
};

function parseTimeToMs(v: unknown): number | undefined {
  if (v == null) return undefined;
  if (typeof v === 'number' && !Number.isNaN(v)) return v;
  const t = Date.parse(String(v));
  return Number.isNaN(t) ? undefined : t;
}

/** 新线程列表项 → 与 sessions.list 一致的 ClawSession（`{ ...row, key, ... }`） */
function threadRowToClawSession(
  row: MarioAgentThreadListRow,
): ClawSession | null {
  const marioAgentId = row.marioAgentId?.trim() ?? '';
  const threadId = row.threadId?.trim() ?? '';
  if (!marioAgentId || !threadId) return null;
  const sessionBase = threadId.replace(/\//g, '-');
  const key = `agent:${marioAgentId}:${sessionBase}`;
  const updatedAt = parseTimeToMs(row.updatedAt);
  const createdAt = parseTimeToMs(row.createdAt);
  return {
    ...row,
    key,
    label: row.title,
    displayName: row.title,
    sessionId: threadId,
    kind: 'direct',
    updatedAt,
    createdAt,
  };
}

/** 新接口列表响应数据转为 ClawSession[] */
export function mapMarioThreadsToClawSessions(rows: MarioAgentThreadListRow[]): ClawSession[] {
  return rows
    .map((row) => threadRowToClawSession(row))
    .filter((s): s is ClawSession => Boolean(s));
}
